import { useCookies } from "vue3-cookies";
export default {
    methods: {
        checkUserCookie() {
            const { cookies } = useCookies();
            if (cookies.get("TVP_MNG_SESS")) {
                return true;
            }
        },
    },
};
